export default __webpack_public_path__ + "static/013a-afeac26cd4b479ba7dc94dc21fa629b4.jpg";